/** The Send SMS action element. */
import { MetadataEntityFieldEditorType, MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { WorkflowActionType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldOptionSource, WorkflowFieldRenderer, WorkflowSideEffect } from '../workflow.element';

/** Sends a templated SMS from the run's Job; the template fills whatever the step leaves out. */
export const SEND_JOB_SMS_ELEMENT: WorkflowElement = {
    type: WorkflowActionType.SendJobSms,
    family: WorkflowFamily.Communication,
    sideEffect: WorkflowSideEffect.Send,
    title: 'Send a templated SMS from the Job',
    icon: 'fa-comment-sms',
    fields: [
        {
            bind: 'input.templateId',
            required: true,
            optionSource: WorkflowFieldOptionSource.SmsTemplates,
            metadata: {
                displayName: 'Template',
                type: MetadataEntityFieldType.Enum,
            },
        },
        {
            bind: 'input.body',
            renderer: WorkflowFieldRenderer.MergeText,
            recordTags: true,
            metadata: {
                displayName: 'Message',
                type: MetadataEntityFieldType.String,
                editor: MetadataEntityFieldEditorType.TextArea,
            },
        },
        {
            bind: 'input.to',
            renderer: WorkflowFieldRenderer.MergeText,
            metadata: {
                displayName: 'To',
                description: 'Mobile numbers separated by commas or semicolons',
                type: MetadataEntityFieldType.String,
                // A list of recipients is accepted as well as separated text.
                arrayOf: MetadataEntityFieldType.String,
            },
        },
    ],
    outputs: [
        { path: 'activityId', metadata: { displayName: 'SMS ID', type: MetadataEntityFieldType.String } },
    ],
};
